module.exports = __webpack_public_path__ + "static/media/arrowMobile.4b695e08.webp";